import { Button } from '../../../../../../components/buttons/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogTitle,
} from '../../../../../../components/dialog';
import { tGlobal, tNamespace } from '../../../../../../services/translation';

const t = tNamespace('app.settings.organization.users');

type UserTransferOwnershipDialogType = {
  dialogTransferState: boolean;
  setDialogTransferState: (state: boolean) => void;
  isLoading: boolean;
  transferOwnership: () => void;
};

export function UserTransferOwnershipDialog(props: UserTransferOwnershipDialogType) {
  const { dialogTransferState, setDialogTransferState, isLoading, transferOwnership } = props;
  return (
    <Dialog open={dialogTransferState} onOpenChange={setDialogTransferState}>
      <DialogContent hasCloseButton>
        <div>
          <DialogTitle>{t('transferOwnership')}</DialogTitle>
          <DialogDescription>{t('transferOwnershipDescription')}</DialogDescription>
          <DialogFooter isColumn>
            <Button
              loading={isLoading}
              size="xl"
              variant="outline"
              className="flex-1"
              onClick={function () {
                setDialogTransferState(false);
              }}
            >
              {tGlobal('cancel')}
            </Button>

            <Button
              loading={isLoading}
              size="xl"
              variant="destructive"
              className="flex-1"
              onClick={function () {
                void transferOwnership();
              }}
            >
              {t('yesTransferOwnership')}
            </Button>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  );
}
